import { Link } from "react-router-dom";

export default function LandingFooter() {
  return (
    <footer className="border-t border-[#E1E9F0] bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div className="flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-[10px] bg-[#3A8FA5] flex items-center justify-center text-white font-bold text-base">Q</span>
          <span className="text-[16px] font-bold tracking-tight text-[#1E3A5F]">Questiomed</span>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-[14px]">
          <Link to="/mentions-legales" className="text-[#5F758F] hover:text-[#1E3A5F] font-semibold" data-testid="footer-legal-mentions">Mentions légales</Link>
          <Link to="/cgu" className="text-[#5F758F] hover:text-[#1E3A5F] font-semibold" data-testid="footer-legal-cgu">CGU</Link>
          <Link to="/cgv" className="text-[#5F758F] hover:text-[#1E3A5F] font-semibold" data-testid="footer-legal-cgv">CGV</Link>
          <Link to="/confidentialite" className="text-[#5F758F] hover:text-[#1E3A5F] font-semibold" data-testid="footer-legal-privacy">Politique de confidentialité</Link>
          <a href="mailto:contact@questiomed.fr" className="text-[#5F758F] hover:text-[#1E3A5F] font-semibold">Contact</a>
        </div>
      </div>
      <div className="border-t border-[#E1E9F0] py-4 px-6 text-center text-[12px] text-[#5F758F]">
        © 2026 Questiomed — Digitalisation des questionnaires cliniques. Hébergement HDS France.
      </div>
    </footer>
  );
}
